import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';

// Obrazki kodów jako SVG w `data:` — ostre przy każdym powiększeniu i każdej drukarce, a
// produkcyjne CSP (`img-src 'self' data: blob:`) je przepuszcza. Bez `innerHTML`: wartość kodu
// pochodzi z danych firmy, a do DOM trafia wyłącznie jako adres obrazka.

const SVG_NS = 'http://www.w3.org/2000/svg';
const toDataUrl = (svg) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

export async function qrDataUrl(value) {
  // Poziom korekcji M: naklejka przetrze się na rogu (kije, kaski) i dalej da się ją odczytać,
  // a kod nie puchnie tak jak przy H — mieści się na etykiecie 38 × 21 mm.
  const svg = await QRCode.toString(String(value), { type: 'svg', margin: 0, errorCorrectionLevel: 'M' });
  return toDataUrl(svg);
}

/** Code 128 — wyłącznie wartość, która przeszła `isCode128Safe` (patrz utils/equipmentCode.js). */
export function code128DataUrl(value) {
  const svg = document.createElementNS(SVG_NS, 'svg');
  JsBarcode(svg, String(value), { format: 'CODE128', displayValue: false, margin: 0, height: 60, width: 2 });
  return toDataUrl(new XMLSerializer().serializeToString(svg));
}

// Kod do pobrania i wydruku poza etykietą (link do rezerwacji, F.4): z marginesem ciszy 4 modułów,
// którego wymaga norma QR, bo obok nie ma ramki etykiety. PNG w rozmiarze do druku na plakacie.
export async function qrSvgDoPobrania(value) {
  const svg = await QRCode.toString(String(value), { type: 'svg', margin: 4, errorCorrectionLevel: 'M' });
  return toDataUrl(svg);
}

export function qrPngDoPobrania(value) {
  return QRCode.toDataURL(String(value), { width: 1024, margin: 4, errorCorrectionLevel: 'M' });
}
